import { fetchJson } from '../fetchUtils';

export const fetchRollbarConfig = async () => {
  const res = await fetchJson('/api/user/getRollbarConfig');
  return res.rollbarConfig;
};

export const fetchIntercomConfig = async () => {
  const res = await fetchJson('/api/user/getIntercomConfig');
  return res.intercomConfig;
};
